import React from 'react'
import ChartPie from '../../../components/ChartPie'

const TicketsByType = ({ticketsByType}) => {
  // Prepare data for the chart: remove the tailwind class 'color' so ChartPie uses default hex colors
  const chartData = ticketsByType.map(({ color, ...rest }) => rest);

  return (
    <div className="w-full h-full">
      <ChartPie 
        data={chartData} 
        title="Tickets por Tipo" 
        dataKey="count" 
        nameKey="label" 
        colors={['#22c55e', '#ef4444']}
      />
    </div>
  )
}

export default TicketsByType
